import { ActionCreatorWithoutPayload, createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IdentityState {
  biometricOptOut: boolean

  biometricApplicantId?: string

  skipBiometricCheck?: boolean
}

/**
 * Initial state for the identity reducer
 */
export const identityInitialState: IdentityState = {
  biometricOptOut: false,
  biometricApplicantId: undefined,
  skipBiometricCheck: undefined,
}

const slice = createSlice({
  name: 'identity',
  initialState: identityInitialState,
  reducers: {
    setBiometricOptOut(state: IdentityState, action: PayloadAction<boolean>): IdentityState {
      return {
        ...state,
        biometricOptOut: action.payload,
      }
    },

    setBiometricApplicantId(state: IdentityState, action: PayloadAction<string | undefined>): IdentityState {
      return {
        ...state,
        biometricApplicantId: action.payload,
      }
    },

    setSkipBiometricCheck(state: IdentityState, action: PayloadAction<boolean | undefined>): IdentityState {
      return {
        ...state,
        skipBiometricCheck: action.payload,
      }
    },

    resetIdentityState(state: IdentityState): IdentityState {
      return identityInitialState
    },
  },
})

export const { setBiometricOptOut, setBiometricApplicantId, setSkipBiometricCheck } = slice.actions
export const resetIdentityState = slice.actions.resetIdentityState as ActionCreatorWithoutPayload

export const identityReducer = slice.reducer
